<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card flat>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="quantity.value"
                label="Quantity"
                outlined
                hide-details="auto"
                :rules="[$rules.required]"
                :disabled="!isAdd"
              />
            </v-col>
            <v-col
              v-if="quantity.colorSpec"
              cols="12"
            >
              <v-select
                v-model="quantity.colorSpec.id"
                :items="print_color_specs"
                item-text="display"
                item-value="id"
                label="Color Spec"
                hide-details="auto"
                outlined
                :rules="[$rules.required]"
                :disabled="!isAdd"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="quantity.cost"
                label="Cost"
                outlined
                :rules="[$rules.required]"
                hide-details="auto"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="quantity.externalId"
                label="External Id"
                outlined
                hide-details="auto"
              />
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-title> Turnarounds </v-card-title>
                <v-card-text>
                  <v-data-table
                    v-model="quantity.turnarounds"
                    :items="print_turnaround_types"
                    :headers="turnaround_headers"
                    disable-pagination
                    hide-default-footer
                    disable-sort
                    show-select
                    item-key="turnaroundType.id"
                  >
                    <template #[`item.cost`]="{ item }">
                      <v-text-field
                        v-model="item.cost"
                        outlined
                        dense
                        hide-details
                        @input="updateCost(item)"
                      />
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <template #append>
      <v-divider />
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import { orderBy, cloneDeep } from 'lodash';
export default {
  name: 'AddPrintQuantity',

  components: {},

  data() {
    return {
      loading: false,
      valid: false,
      saving: false,
      drawer: false,
      quantity: {},
      product: {},
      turnaround_headers: [
        { text: 'Name', value: 'display' },
        { text: 'Cost', value: 'cost' }
      ]
    };
  },

  computed: {
    isAdd() {
      return !this.quantity.id;
    },
    title() {
      return !this.isAdd ? 'Edit Print Quantity' : 'Add Print Quantity';
    },
    print_color_specs() {
      return orderBy(this.print_lookups?.color_specs || [], ['display'], ['asc']).filter(
        (x) => x.providerId === this.product.providerId
      );
    },
    print_turnaround_types() {
      return orderBy(this.print_lookups?.turnaround_types || [], ['days'], ['asc'])
        .filter((x) => x.providerId === this.product.providerId)
        .map((x) => ({
          turnaroundType: { id: x.id },
          cost:
            this.quantity.turnarounds
              .filter((y) => y.turnaroundType.id === x.id)
              .map((y) => y.cost)[0] || 0,
          display: x.display
        }));
    },
    ...mapGetters({
      units: 'lookup/units',
      print_providers: 'lookup/print_providers',
      fourover_list: 'print/fourover_list',
      print_lookups: 'print/lookups'
    })
  },

  async mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.EDIT_PRINT_QUANTITY_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.EDIT_PRINT_QUANTITY_SHOW, (data) => {
      this.quantity = cloneDeep(data.quantity) || {
        turnarounds: [],
        productId: data.product.id,
        colorSpec: {}
      };
      this.product = data.product;
      this.drawer = true;
    });
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('print/saveQuantity', this.quantity)
        .then(() => {
          this.$root.$snackbarSuccess('Print Quantity saved');
          this.$emit('save');
          this.drawer = false;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    updateCost(item) {
      const turnaround = this.quantity.turnarounds.find(
        (x) => x.turnaroundType.id === item.turnaroundType.id
      );
      if (turnaround) {
        turnaround.cost = parseFloat(item.cost);
      }
    }
  }
};
</script>
